<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      @if (!loading) {
        <div class="ui-g card mt-4">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="engactivity">
              <div class="sbhd">Number of Activities Requiring Action</div>
              <table>
                <tr>
                  <td class="engtdpanel">
                    Customer Ack Pending Approval<br /><span>{{
                      activityCount.customerAckApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Customer Survey Pending Approval<br /><span>{{
                      activityCount.customerSurveyApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Findings Document Pending Approval<br /><span>{{
                      activityCount.findingsDocumentApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Invoice Pending Approval<br /><span>{{
                      activityCount.invoiceApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    RFP Award Letter Pending Approval<br /><span>{{
                      activityCount.rfpAwardLetterCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    RFP Description Pending Approval<br /><span>{{
                      activityCount.rfpDescriptionCount
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
